<div class="page-holder bg-gray-100">
    <div class="col-lg-12 container-fluid px-lg-4 px-xl-5">
          <!-- Page Header-->
          <div class="page-header">
            <h1 class="page-heading">View Form</h1>
          </div>
      <section>
          
        <div class="card-body">
            <button class="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#myModal">Form in a simple modal </button>
            <ng-template #mymodal let-modal>
                <div class="modal-header">
                  <h4 class="modal-title" id="modal-basic-title">Bootstrap Modal</h4>
                  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-body">
                  This is example from ItSolutionStuff.com
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button>
                </div>
              </ng-template>
            <!-- Modal-->
            <div class="modal fade text-start" id="myModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header border-0 bg-gray-100">
                    <h3 class="h5 text-uppercase modal-title" id="exampleModalLabel">Signin Modal</h3>
                    <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <p>Lorem ipsum dolor sit amet consectetur.</p>
                    <form>
                      <div class="mb-3">
                        <label>Email</label>
                        <input class="form-control" type="email" placeholder="Email Address">
                      </div>
                      <div class="mb-3">       
                        <label>Password</label>
                        <input class="form-control" type="password" placeholder="Password">
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer border-0 bg-gray-100">
                    <button class="btn btn-secondary" type="button" data-bs-dismiss="modal">Close</button>
                    <button class="btn btn-primary" type="button">Save changes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div class="row mb-5">
          <div class="col-lg-12">
            <div class="card mb-4 mb-lg-0">
              <div class="card-body min-w">
                <div class="mb-4">
                  <label class="form-label" for="categoryName">Inspector Name</label>
                  <input class="form-control" id="categoryName" type="text">
                </div>
                <div class="mb-4">
                    <label class="form-label">Date time inspection started</label>
                    <input class="form-control" type="date" id="inspectDate" name="inspectDate">
                </div>
                <div class="mb-4">
                  <label class="form-label" for="categorySlug">Facility Name</label>
                  <input class="form-control" id="categorySlug" type="text">
                </div>
                <div class="mb-4">
                    <label class="form-label" for="categorySlug">Facility GPS</label>
                    <input class="form-control" id="categorySlug" type="text">
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="categorySlug">MP2 work order number, if applicable</label>
                    <input class="form-control" id="categorySlug" type="text">
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="categorySlug">Weather data reference ( to be field verfied)</label>
                    <input class="form-control" id="categorySlug" type="text">
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="categorySlug">Nature of Discharge</label>
                    <input class="form-control" id="categorySlug" type="text">
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="categorySlug">If Rainfall, Rainfall amount (in)</label>
                    <input class="form-control" id="categorySlug" type="text">
                  </div>
                 
                  <div class="mb-4">
                    <label class="form-label" for="prevStorm">Previous strom ended>72 before start of this strom?</label>
                    <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline1">Yes</label>
                        <input class="form-check-input" id="customRadioInline1" type="radio" name="customRadioInline1">
                      </div>
                      <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline2">No</label>
                        <input class="form-check-input" id="customRadioInline2" type="radio" name="customRadioInline1">
                      </div>
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="categorySlug">Duration of rain event (hours)</label>
                    <input class="form-control" id="categorySlug" type="text">
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="categorySlug">Volume of discharge</label>
                    <input class="form-control" id="categorySlug" type="text">
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="categorySlug">Outfall ID</label>
                    <input class="form-control" id="categorySlug" type="text">
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="prevStorm">Is strormwater discharging from this outfall at the time of this objservation?</label>
                    <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline1">Yes</label>
                        <input class="form-check-input" id="customRadioInline1" type="radio" name="customRadioInline1">
                      </div>
                      <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline2">No</label>
                        <input class="form-check-input" id="customRadioInline2" type="radio" name="customRadioInline1">
                      </div>
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="prevStorm">Could sample not be collected due to adverse weather conditions?</label>
                    <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline1">Yes</label>
                        <input class="form-check-input" id="customRadioInline1" type="radio" name="customRadioInline1">
                      </div>
                      <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline2">No</label>
                        <input class="form-check-input" id="customRadioInline2" type="radio" name="customRadioInline1">
                      </div>
                  </div>
                  <div class="mb-4">
                    <label class="form-label">Date Time discharge began</label>
                    <input class="form-control" type="date" id="dischargeDate" name="dischargeDate">
                </div>
                <div class="mb-4">
                    <label class="form-label" for="prevStorm">Is this a “Substantially Identical Outfall”?</label>
                    <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline1">Yes</label>
                        <input class="form-check-input" id="customRadioInline1" type="radio" name="customRadioInline1">
                      </div>
                      <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline2">No</label>
                        <input class="form-check-input" id="customRadioInline2" type="radio" name="customRadioInline1">
                      </div>
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="prevStorm">Are there any non-stormwater discharging present?</label>
                    <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline1">Yes</label>
                        <input class="form-check-input" id="customRadioInline1" type="radio" name="customRadioInline1">
                      </div>
                      <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline2">No</label>
                        <input class="form-check-input" id="customRadioInline2" type="radio" name="customRadioInline1">
                      </div>
                  </div>
                  
                <div class="mb-4">
                  <label class="form-label" for="categoryDescription">Additional Comments</label>
                  <textarea class="form-control" id="categoryDescription" name="categoryDescription"></textarea>
                </div>
                <div class="mb-4">
                    <label class="form-label" for="prevStorm">Are there any non-stormwater discharging present?</label>
                    <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline1">Yes</label>
                        <input class="form-check-input" id="customRadioInline1" type="radio" name="customRadioInline1">
                      </div>
                      <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline2">No</label>
                        <input class="form-check-input" id="customRadioInline2" type="radio" name="customRadioInline1">
                      </div>
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="categorySlug">#of Outfalls Inspected out of # of Outfalls to Inspect</label>
                    <input class="form-control" id="categorySlug" type="text">
                  </div>
                <div class="mb-4">
                    <label class="form-label" for="categorySlug">Inspector Name</label>
                    <input class="form-control" id="categorySlug" type="text">
                  </div>
                  <div class="mb-4">
                    <label class="form-label" for="prevStorm">Is this inspection form submittal a revised version of an earlier submittal?</label>
                    <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline1">Yes</label>
                        <input class="form-check-input" id="customRadioInline1" type="radio" name="customRadioInline1">
                      </div>
                      <div class="form-check">
                        <label class="custom-control-label" for="customRadioInline2">No</label>
                        <input class="form-check-input" id="customRadioInline2" type="radio" name="customRadioInline1">
                      </div>
                  </div>
                  <div class="mb-4">
                    <label class="form-label">Inspection Completion Date</label>
                    <input class="form-control" type="date" id="dischargeDate" name="dischargeDate">
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <app-footer class="footer-w"></app-footer>
  </div>